import type { RouteRecordRaw } from 'vue-router';

export const INVENTORY_SITUATION_ROUTER: RouteRecordRaw[] = [
  {
    path: '/sales/byitem',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/sales/byitem/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/sales/byItem/views/List.vue'),
        name: 'By Item List',
        meta: {
          title: '항목별 매출조회',
        },
      },
    ],
  },
];
